/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import * as Yup from 'yup';
import trialSessionFormModel from './FormModel';

const {
  formField: {
    studioId,
    formOfTraining,
    gender,
    dueDate,
    firstName,
    lastName,
    email,
    phonePrefix,
    phone,
    generalTerms,
    marketingTerms,
    dateOfBirth,
  },
} = trialSessionFormModel;

const phoneRegExp = /^([1-9][0-9]*)+$/;

export default [
  Yup.object().shape({
    [studioId.name]: Yup.string().required(`${studioId.requiredErrorMsg}`),
    [formOfTraining.name]: Yup.string().required(`${formOfTraining.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [dueDate.name]: Yup.string().required(`${dueDate.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [firstName.name]: Yup.string()
      .required(`${firstName.requiredErrorMsg}`)
      .min(2, 'Dieses Feld muss mindestens 2 Zeichen enthalten'),
    [lastName.name]: Yup.string()
      .required(`${lastName.requiredErrorMsg}`)
      .min(2, 'Dieses Feld muss mindestens 3 Zeichen enthalten'),
    [gender.name]: Yup.string().required(`${gender.requiredErrorMsg}`),
    [email.name]: Yup.string()
      .required(`${email.requiredErrorMsg}`)
      .email('Bitte geben Sie eine gültige E-Mail-Adresse an'),
    [phonePrefix.name]: Yup.string().required(`${phonePrefix.requiredErrorMsg}`),
    [phone.name]: Yup.string()
      .required(`${phone.requiredErrorMsg}`)
      .matches(phoneRegExp, 'Bitte überprüfen Sie die Eingabe auf ungültige Zeichen. Die Eingabe darf nicht mit 0 oder dem Ländercode beginnen.')
      .min(5, 'Bitte überprüfen Sie die länge der eingegebenen Zeichen')
      .max(15, 'Bitte überprüfen Sie die länge der eingegebenen Zeichen'),
    [generalTerms.name]: Yup.string().required(`${generalTerms.requiredErrorMsg}`),
    [marketingTerms.name]: Yup.string().required(`${marketingTerms.requiredErrorMsg}`),
    [dateOfBirth.name]: Yup.string().required(`${dateOfBirth.requiredErrorMsg}`),
  }),
];

export const useTrialSessionValidatorGenerator = () => {
  const getStudioSchema = () => ({
    [studioId.name]: Yup.string().required(`${studioId.requiredErrorMsg}`),
    [formOfTraining.name]: Yup.string().required(`${formOfTraining.requiredErrorMsg}`),
  });
  const getDueDateSchema = () => ({
    [dueDate.name]: Yup.string().required(`${dueDate.requiredErrorMsg}`),
  });
  const getPersonalDataSchema = () => ({
    [firstName.name]: Yup.string()
      .required(`${firstName.requiredErrorMsg}`)
      .min(2, 'Dieses Feld muss mindestens 2 Zeichen enthalten'),
    [lastName.name]: Yup.string()
      .required(`${lastName.requiredErrorMsg}`)
      .min(2, 'Dieses Feld muss mindestens 3 Zeichen enthalten'),
    [gender.name]: Yup.string().required(`${gender.requiredErrorMsg}`),
    [email.name]: Yup.string()
      .required(`${email.requiredErrorMsg}`)
      .email('Bitte geben Sie eine gültige E-Mail-Adresse an'),
    [phonePrefix.name]: Yup.string().required(`${phonePrefix.requiredErrorMsg}`),
    [phone.name]: Yup.string()
      .required(`${phone.requiredErrorMsg}`)
      .matches(phoneRegExp, 'Bitte überprüfen Sie die Eingabe auf ungültige Zeichen. Die Eingabe darf nicht mit 0 oder dem Ländercode beginnen.')
      .min(5, 'Bitte überprüfen Sie die länge der eingegebenen Zeichen')
      .max(15, 'Bitte überprüfen Sie die länge der eingegebenen Zeichen'),
    [generalTerms.name]: Yup.string().required(`${generalTerms.requiredErrorMsg}`),
    [marketingTerms.name]: Yup.string().required(`${marketingTerms.requiredErrorMsg}`),
    [dateOfBirth.name]: Yup.string().required(`${dateOfBirth.requiredErrorMsg}`),
  });

  const generateSchema = () => [
    Yup.object().shape(getStudioSchema()),
    Yup.object().shape(getDueDateSchema()),
    Yup.object().shape(getPersonalDataSchema())];
  return { generateSchema };
};
